import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { APP_MAIN_TAG_ID } from 'utils/constants';

export default function ScrollToTop({ children = null }) {
  const { pathname, hash, state } = useLocation();

  useEffect(() => {
    if (!hash && !state?.background) {
      const main = document.getElementById(APP_MAIN_TAG_ID);
      if (main) main.focus();
      window.scrollTo(0, 0);
    } else {
      // if hash is present, scroll element with hash id into view
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView();
        // always focus on element being scrolled to for accessibility, this requires the element to be focusable
        const originalTabIndex = element.getAttribute('tabIndex');
        if (!originalTabIndex) element.setAttribute('tabIndex', -1); // ensure's that if an item was scrolled to it is capable of being focused
        element.focus();
      }
    }
  }, [pathname, hash, state]);

  return children || null;
}

ScrollToTop.propTypes = {
  children: PropTypes.node,
};
